import { QuestionnaireAnswers } from "features/onboarding/questionnaire";

const DANISH_LABELS: Record<string, string> = {
  "onboarding-questionnaire-roles-admin-item": "Ejer/Administrator",
  "onboarding-questionnaire-roles-forester-item": "Skovforvalter/Naturforvalter",
  "onboarding-questionnaire-roles-consultant-item": "Konsulent/Entreprenør",
  "onboarding-questionnaire-roles-farmer-item": "Landmand",
  "onboarding-questionnaire-roles-researcher-item": "Forskning og undervisning",
  "onboarding-questionnaire-roles-student-item": "Studerende",
  "onboarding-questionnaire-roles-other-item": "Andet",
  "onboarding-questionnaire-amount-1": "1 ejendom",
  "onboarding-questionnaire-amount-2-5": "2–5 ejendomme",
  "onboarding-questionnaire-amount-6-10": "6–10 ejendomme",
  "onboarding-questionnaire-amount-11-20": "11–20 ejendomme",
  "onboarding-questionnaire-amount-21-50": "21–50 ejendomme",
  "onboarding-questionnaire-amount-51+": "51+ ejendomme",
  "onboarding-questionnaire-amount-non": "Arbejder ikke direkte med ejendomme",
  "onboarding-questionnaire-size-under-10-ha": "Under 10 hektar",
  "onboarding-questionnaire-size-10-50": "10–50 hektar",
  "onboarding-questionnaire-size-51-150": "51–150 hektar",
  "onboarding-questionnaire-size-151-500": "151–500 hektar",
  "onboarding-questionnaire-size-501-1000": "501–1000 hektar",
  "onboarding-questionnaire-size-over-1000": "Over 1000 hektar",
  "onboarding-questionnaire-purpose-management": "Skovbrug og drift",
  "onboarding-questionnaire-purpose-nature": "Natur og biodiversitet",
  "onboarding-questionnaire-purpose-analysis": "Analyse og rapportering",
  "onboarding-questionnaire-purpose-sharing": "Styring og deling af data",
  "onboarding-questionnaire-purpose-stakeholder": "Samarbejde og koordinering",
  "onboarding-questionnaire-purpose-planning": "Planlægning og drift",
  "onboarding-questionnaire-purpose-other": "Andet",
};

let pendingWelcome = false;

export const schedulePendingWelcome = (): void => {
  pendingWelcome = true;
};

export const consumePendingWelcome = (): boolean => {
  const v = pendingWelcome;
  pendingWelcome = false;
  return v;
};

const GEORGE_ONBOARDING_TEMPLATE =
  `[INTERNAL] Du møder en ny bruger for første gang. Brugerens profil:
- Rolle: {role}
- Antal ejendomme/områder: {amount}
- Samlet areal: {size}
- Primære fokusområder: {purposes}
Præsenter dig selv og byd brugeren velkommen til George. Hold det kort — 3–4 sætninger. Anerkend deres profil og foreslå 1–2 konkrete ting de kan starte med at udforske. Tjek UI Knowledgebase for hvad der er relevant for deres fokusområde. Tone: klar, rolig og professionel. Ikke overentusiastisk, ikke salgsorienteret. Svar direkte til brugeren.
Husk: brugeren er ny og har sandsynligvis ingen data i systemet endnu. Forslag skal tage udgangspunkt i at komme i gang fra bunden — ikke i at arbejde med eksisterende kort, registreringer eller opgaver.`;

const GEORGE_ONBOARDING_GENERIC =
  `[INTERNAL] Du møder en ny bruger for første gang. Præsenter dig selv og byd brugeren velkommen til George. Hold det kort — 3–4 sætninger. Forklar hvad du kan hjælpe med. Tone: klar, rolig og professionel.`;

export const buildOnboardingPrompt = (answers: QuestionnaireAnswers | undefined): string => {
  if (!answers?.role) return GEORGE_ONBOARDING_GENERIC;
  const role = (answers.roleId && DANISH_LABELS[answers.roleId]) || answers.role;
  const amount = (answers.estatesId && DANISH_LABELS[answers.estatesId]) || answers.estates;
  const size = (answers.hectaresId && DANISH_LABELS[answers.hectaresId]) || answers.hectares;
  const purposes =
    Array.isArray(answers.purposesIds) && answers.purposesIds.length > 0
      ? answers.purposesIds.map((id) => DANISH_LABELS[id] ?? id).join(", ")
      : answers.purposes?.join(", ") ?? "";
  return GEORGE_ONBOARDING_TEMPLATE
    .replace("{role}", role)
    .replace("{amount}", amount)
    .replace("{size}", size)
    .replace("{purposes}", purposes);
};
